"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FilterMenuButton = void 0;
var react_1 = __importDefault(require("react"));
var StatelessMenu_1 = require("@kaizen/draft-menu/KaizenDraft/Menu/StatelessMenu");
var FilterSplitButton_1 = require("./FilterSplitButton");
var FilterMenuButton_module_scss_1 = __importDefault(require("./FilterMenuButton.module.scss"));
var FilterMenuButton = function (_a) {
    var id = _a.id, labelText = _a.labelText, children = _a.children, metadata = _a.metadata, _b = _a.autoHide, autoHide = _b === void 0 ? "on" : _b, isDropdownVisible = _a.isDropdownVisible, toggleDropdown = _a.toggleDropdown, hideDropdown = _a.hideDropdown, onFilterClear = _a.onFilterClear;
    var dropdownId = "".concat(id, "-dropdown");
    return (react_1["default"].createElement("div", { id: id, className: FilterMenuButton_module_scss_1["default"].filterMenuButton },
        react_1["default"].createElement(StatelessMenu_1.StatelessMenu, { renderButton: function (_a) {
                var onClick = _a.onClick, onMouseDown = _a.onMouseDown;
                return (react_1["default"].createElement(FilterSplitButton_1.FilterSplitButton, __assign({}, {
                    isDropdownVisible: isDropdownVisible,
                    onFilterClear: onFilterClear,
                    labelText: labelText,
                    metadata: metadata,
                    onClick: onClick,
                    onMouseDown: onMouseDown,
                    ariaExpanded: isDropdownVisible,
                    ariaControls: dropdownId
                })));
            }, isMenuVisible: isDropdownVisible, toggleMenuDropdown: toggleDropdown, hideMenuDropdown: hideDropdown, dropdownWidth: "contain", dropdownId: dropdownId, autoHide: autoHide, onClick: function (e) { return e.stopPropagation(); } }, children)));
};
exports.FilterMenuButton = FilterMenuButton;
//# sourceMappingURL=FilterMenuButton.js.map